
import { Component } from 'react';
import PropTypes from 'prop-types';

import merge from 'lodash-es/merge';

import options from '../../data/options.json';

import Schools from './Index.jsx';
import Navigation from '../Navigation.jsx';

export default class SchoolsContainer extends Component {
    constructor(props) {
        super(props);

        const countyFromUrl = this.getCountyFromUrl();

        this.state = {
            schools: props.schools,
            filteredSchools: this.deterministicShuffle(this.props.schools, false),
            filters: {
                active: countyFromUrl !== '',
                schools: {
                    name: '',
                    christian: '',
                    hc: '',
                    county: countyFromUrl,
                    schoolname: '',
                },
            },
            options: options
        };

        this.setSchoolsFilters = this.setSchoolsFilters.bind(this);
        this.filterSchools = this.filterSchools.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        this.shuffle = this.shuffle.bind(this);
        this.unShuffle = this.unShuffle.bind(this);
    }

    componentDidMount() {
        if (this.state.filters.schools.county !== '') {
            this.filterSchools();
        }
    }

    getCountyFromUrl() {
        const match = window.location.pathname.match(/\/skoler\/region\/([^/]+)/);
        if (!match) return '';
        const slug = match[1];
        const county = options.schools.county.find(c => this.countySlug(c.name) === slug);
        return county ? [county.key] : '';
    }

    countySlug(name) {
        return name.toLowerCase().replace(/ø/g, 'o').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    }

    updateUrl(countyFilter) {
        if (this.props.lang !== 'no') {
            return null;
        }

        if (countyFilter && countyFilter.length === 1) {
            const county = options.schools.county.find(c => c.key === countyFilter[0]);
            if (county) {
                window.history.replaceState(null, '', `/skoler/region/${this.countySlug(county.name)}`);
                return;
            }
        }
        window.history.replaceState(null, '', '/skoler');
    }

    setSchoolsFilters(field, type) {
        let newFilters = null;

        if (type === 'christian') {
            newFilters = {
                christian: field.length ? field : null
            };
        }
        else if (type === 'county') {
            newFilters = {
                county: field.length ? field : null
            };
        }
        else if (type === 'hc') {
            newFilters = {
                hc: field
            };
        }
        else if (type === 'search') {
            newFilters = {
                schoolname: field
            };
        }

        if (newFilters) {
            let filters = merge(
                this.state.filters,
                {
                    active: true,
                    schools: newFilters
                }
            );
            return this.setState({ filters }, () => {
                this.filterSchools();
                this.updateUrl(this.state.filters.schools.county);
            });
        }

        return null;
    }

    getChristianFilter(field) {
        let christianFilter = '';

        if (field && field.length) {
            let atheist = field.includes("false");
            let christian = field.includes("true");
            if (atheist && !christian) {
                christianFilter = false;
            }
            else if (!atheist && christian) {
                christianFilter = true;
            }
        }

        return christianFilter;
    }

    filterSchools() {
        const schoolFilters = this.state.filters.schools;

        let christianFilter = this.getChristianFilter(schoolFilters.christian);

        const isSchoolNameMatch = (schoolname, filter) => {
            const actualFilter = filter.replace('risøya', 'risøy');
            let result = schoolname.includes(actualFilter);

            if (result) {
                return true;
            }

            const synonyms = ['folkehøgskole', 'folkehøgskule', 'folkehøyskole'];
            const searchWords = actualFilter.split(' ');
            let synonymWord = synonyms.filter(w => searchWords.includes(w));

            if (synonymWord.length === 1) {
                synonymWord = synonymWord[0];
                for (let i=0; i<synonyms.length; i++) {
                    let synonym = synonyms[i];
                    if (synonym == synonymWord) {
                        continue;
                    }
                    let synonymFilter = actualFilter.replace(synonymWord, synonym);
                    result = schoolname.includes(synonymFilter);
                    if (result) {
                        return true;
                    }
                }
            }

            return false;
        };

        const results = this.state.schools.filter((school) =>
            (christianFilter !== '' ?
                school.christian === christianFilter :
                school.christian !== null
            )
            &&
            ((schoolFilters.county) ?
                schoolFilters.county.includes(school.r + "") :
                school.r !== null
            )
            &&
            ((schoolFilters.hc !== '') ?
                school.hc === schoolFilters.hc :
                schoolFilters.hc !== null
            )
            &&
            ((schoolFilters.schoolname !== '') ?
                isSchoolNameMatch(school.schoolname.toLowerCase(), schoolFilters.schoolname.toLowerCase()) :
                school.schoolname !== null
            )
        );

        this.setState({ filteredSchools: results });
    }

    shuffle() {
        this.setState({
            filteredSchools: this.deterministicShuffle(this.state.filteredSchools, true)
        });
    }

    unShuffle() {
        FHS.track('skolesøk', 'sort');
        let schools = this.state.filteredSchools
        schools.sort((a, b) => a.schoolname.localeCompare(b.schoolname));
        this.setState({
            filteredSchools: schools
        });
    }

    /** Shuffle with option to reuse old order if already set */
    deterministicShuffle(elements, forceNewOrder) {
        let order = false;
        let n = elements.length;

        if (!forceNewOrder) {
            // attempt to get old ordering from sessionStorage and ensure it's fresh
            const storedOrder = sessionStorage.getItem('schoolOrder');
            const storedTime = sessionStorage.getItem('schoolOrderTime');

            const now = Date.now();
            const storedMs = storedTime ? parseInt(storedTime, 10) : 0;
            const isExpired = (now - storedMs) > (10 * 60 * 1000); // should last ten minutes

            if (storedOrder && !isExpired) {
                order = JSON.parse(storedOrder);
            }
        }
        if (!order || order.length !== n) {
            // generate new ordering, save to localstorage
            order = [];
            let indexes = [];
            for (let i = 0; i < n; i++) {
                indexes.push(i);
            }
            for (let i = 0; i < n-1; i++) {
                order.push(indexes.splice(Math.floor(Math.random()*indexes.length),1)[0]);
            }
            order.push(indexes[0]);
            sessionStorage.setItem('schoolOrder', JSON.stringify(order));
            sessionStorage.setItem('schoolOrderTime', Date.now().toString());
        }

        // restore original order
        elements.sort((a, b) => {
            if (a.index < b.index) return -1;
            if (a.index > b.index) return 1;
            return 0;
        });

        // use temp array to sort in place
        let temp = elements.slice(0);

        for (let i = 0; i < n; i++) {
            elements[i] = temp[order[i]];
        }

        return elements;
    }

    resetFilters() {
        this.setState({
            filteredSchools: this.props.schools,
            filters: {
                active: false,
                schools: {
                    name: '',
                    christian: '',
                    hc: '',
                    county: '',
                    schoolname: '',
                },
            },
        });
        window.history.replaceState(null, '', '/skoler');
    }

    render() {
        let navigation = this.props.lang === 'no' ? <Navigation /> : '';
        return (
            <div>
                {navigation}
                <Schools
                    filteredSchools={this.state.filteredSchools}
                    sortSchools={this.setSchoolsFilters}
                    resetFilters={this.resetFilters}
                    shuffle={this.shuffle}
                    unShuffle={this.unShuffle}
                    options={this.state.options}
                    filters={this.state.filters}
                    filtersActive={this.state.filters.active}
                    lang={this.props.lang}
                />
            </div>
        );
    }
}

SchoolsContainer.propTypes = {
    schools: PropTypes.array,
};